import {Component, Input, OnChanges, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {IoniconsFilled} from "@pt/pt-models";

@Component({
  selector: 'pt-widget-multi-question-v0-check-button',
  styles: [`
    .select-item {
      width: 100%;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #333333 !important;
    }

    .ng-value-custom {
      width: 80px;
      overflow: hidden;
      white-space: nowrap;
      display: block;
      text-overflow: ellipsis;
    }

  `],
  encapsulation: ViewEncapsulation.None,
  template: `
    <ng-select
      class="ng-select-custom"
      appendTo="body"
      [items]="currentAnswers"
      [multiple]="true"
      [bindValue]="'label'"
      [ngModel]="answersSelected"
      [readonly]="false"
      [searchable]='false'
      [clearable]='false'>
      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        <div class="ng-value ng-value-custom" *ngFor="let item of answersSelected | slice:0:1">
          {{ item }}
        </div>
        <div class="ng-value" *ngIf="items.length > 1">
          <span class="ng-value-label">{{ items.length - 1 }} more...</span>
        </div>
      </ng-template>

      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        {{ item.label }}
      </ng-template>

      <ng-template ng-option-tmp let-item="item" let-index="index">
        <div class="select-item"
             container='body'
             ngbTooltip="{{item.label}}">
          <pt-icon class='widget-icon-preview-color'
                   *ngIf='value.includes(index)'
                   [key]='IconCheckboxCheck'
          ></pt-icon>
          <pt-icon class='widget-icon-preview-color-disabled'
                   *ngIf='!value.includes(index)'
                   [key]='IconCheckboxUnCheck'>
          </pt-icon>
          {{ item.label }}
        </div>
      </ng-template>
    </ng-select>
  `,
})
export class WidgetMultiQuestionV0CheckButtonComponent implements OnChanges {
  @Input() noResponseLabel: string;
  @Input() value: number[];
  @Input() answers: string[];
  @Input() readonly = true;
  public noValue: boolean;
  currentAnswers: { label: string, disabled: boolean }[] = [];

  IconCheckboxCheck = IoniconsFilled.checkbox;
  IconCheckboxUnCheck = IoniconsFilled.checkboxUnchecked;
  answersSelected: string[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.value || this.value.length === 0) {
      this.noValue = true;
    } else {
      this.noValue = false;
      this.answersSelected = [];
      this.value.forEach(v => {
        if (this.answers.length > v) {
          this.answersSelected.push(this.answers[v]);
        }
      })
    }
    this.currentAnswers = this.answers.map(a => {
      return {label: a, disabled: true}
    });

  }
}


/*
<!--                        <div class='form-check multiquestion-form-check me-3 mb-2'-->
                        <!--                             [ngClass]='[question?.answers.length <= 5 ? "w-100" : ""]'-->
                        <!--                             *ngFor='let o of question.answers; let iResponse = index'>-->
                        <!--                          <pt-icon class='widget-icon-preview-color'-->
                        <!--                                   *ngIf='isChecked(iResponse, o.checkboxValue)'-->
                        <!--                                   [key]='IconCheckboxCheck'-->
                        <!--                          ></pt-icon>-->

                        <!--                          <pt-icon class='widget-icon-preview-color-disabled'-->
                        <!--                                   *ngIf='!isChecked(iResponse, o.checkboxValue)'-->
                        <!--                                   [key]='IconCheckboxUnCheck'-->
                        <!--                          ></pt-icon>-->
                        <!--                          {{o}}-->
                        <!--                  <div *ngSwitchCase="'CHECKBOX'"-->
                        <!--                       [ngClass]='[q?.answers.length > 5 ? "wmq-wrap" : ""]'>-->
                        <!--                    <div class='wmq-item'-->
                        <!--                         [ngClass]='[q?.answers.length <= 5 ? "w-100" : ""]'-->
                        <!--                         *ngFor='let response of q?.answers; let iResponse = index'>-->
                        <!--                      <pt-icon class='widget-icon-preview-color'-->
                        <!--                               *ngIf='isChecked(iResponse, q.checkboxValue)'-->
                        <!--                               [key]='IconCheckboxCheck'-->
                        <!--                      ></pt-icon>-->

                        <!--                      <pt-icon class='widget-icon-preview-color-disabled'-->
                        <!--                               *ngIf='!isChecked(iResponse, q.checkboxValue)'-->
                        <!--                               [key]='IconCheckboxUnCheck'-->
                        <!--                      ></pt-icon>-->
                        <!--                      {{response}}-->
                        <!--                    </div>-->


                        <!--                          <input class='form-check-input'-->
                        <!--                                 type='checkbox'-->
                        <!--                                 (change)='clickCheckbox(iResponse, question.uuid, $any($event.target).checked)'-->
                        <!--                                 [value]='iResponse'-->
                        <!--                                 [checked]='includeCheckbox(question.checkboxValue, iResponse)'-->
                        <!--                                 [id]='uniqueId + question.uuid + iResponse'>-->
                        <!--                          <label class='form-check-label'-->
                        <!--                                 [htmlFor]='uniqueId + question.uuid + iResponse'>-->
                        <!--                            {{o}}-->
                        <!--                          </label>-->
 */
